import popMdsResult from "../action/popMdsResult";
import searchMdsAction from '../action/searchMdsAction';
import voc from '../action/voc';
import semi from '../action/semi';
import createcom from '../action/createcom';
import viewmds from '../action/viewmds';
import mdsdatarequest from '../action/mdsDataRequest';
import metarial from '../action/metarial';
import semicom from '../action/semicom';
import submet from '../action/submet';
import showSub from '../action/showSub';
import receivemds from '../action/receivemds';
import sendMds from '../action/sendMds';
import preview from '../action/preview';
import analyse from '../action/analyse'
import basicInfo from '../action/basicInfo';
import MDSMaterialCreateAction from '../action/MDSMaterialCreateAction';
import showMaterial from '../action/showMaterial';
import mdssuplier from '../action/mdssuplier';
import customcheck from '../action/customcheck';
import selectMDSAction from '../action/selectMDSAction';
import mdsResult from '../action/mdsResult';
import recoveryanalyse from '../action/recoveryanalyse';
import mdsrecipient from '../action/mdsrecipient';
import mdsValidateAction from '../action/mdsValidateAction';
import global from '../action/global'
import delMds from '../action/delMds'
import passwordChange from '../action/passwordChange'
import announcement from '../action/announcement'
import auxiliaryVerificationTool from '../action/auxiliaryVerificationTool'
import setUp from '../action/setUp'
import close from '../action/close'
import auxiliaryTools from '../action/auxiliaryTools'
import substanceResult from '../action/substanceResult'
import refusedmds from '../action/refusedmds'
import ruleNotice from '../action/ruleNotice'
import publishext from '../action/publishext'
import MDSClassManage from '../action/MDSClassManage'
import enterpriseContactPerson from '../action/enterpriseContactPerson'
import common from '../action/common'
import noticeManage from '../action/noticeManage'
import help from '../action/help'
export default {
  title: "中国汽车材料数据系统",
  popMdsResult: popMdsResult.ZH,
  searchMdsAction: searchMdsAction.ZH,
  voc: voc.ZH,
  semi: semi.ZH,
  createcom: createcom.ZH,
  viewmds: viewmds.ZH,
  mdsdatarequest: mdsdatarequest.ZH,
  metarial: metarial.ZH,
  semicom: semicom.ZH,
  submet: submet.ZH,
  showSub: showSub.ZH,
  receivemds: receivemds.ZH,
  sendMds: sendMds.ZH,
  preview: preview.ZH,
  basicInfo: basicInfo.ZH,
  MDSMaterialCreateAction: MDSMaterialCreateAction.ZH,
  showMaterial: showMaterial.ZH,
  mdssuplier: mdssuplier.ZH,
  customcheck: customcheck.ZH,
  selectMDSAction: selectMDSAction.ZH,
  mdsResult: mdsResult.ZH,
  recoveryanalyse: recoveryanalyse.ZH,
  mdsrecipient: mdsrecipient.ZH,
  mdsValidateAction: mdsValidateAction.ZH,
  global: global.ZH,
  delMds: delMds.ZH,
  passwordChange: passwordChange.ZH,
  announcement: announcement.ZH,
  auxiliaryVerificationTool: auxiliaryVerificationTool.ZH,
  setUp: setUp.ZH,
  close: close.ZH,
  auxiliaryTools: auxiliaryTools.ZH,
  substanceResult: substanceResult.ZH,
  refusedmds: refusedmds.ZH,
  ruleNotice: ruleNotice.ZH,
  publishext:publishext.ZH,
  MDSClassManage:MDSClassManage.ZH,
  enterpriseContactPerson:enterpriseContactPerson.ZH,
  noticeManage:noticeManage.ZH,
  common: common.ZH,
  help: help.ZH,
  receivecompliance: {
    table: '\u6709\u5BB3\u7269\u8D28\u5408\u89C4\u4FE1\u606F',
    stautsTable: "\u67E5\u770B\u5408\u89C4\u4FE1\u606F"
  },
  route: {
    dashboard: "首页",
    documentation: "文档",
    guide: "引导页",
    permission: "权限测试页",
    rolePermission: "角色权限",
    pagePermission: "页面权限",
    directivePermission: "指令权限",
    icons: "图标",
    components: "组件",
    tinymce: "富文本编辑器",
    markdown: "Markdown",
    jsonEditor: "JSON 编辑器",
    dndList: "列表拖拽",
    splitPane: "Splitpane",
    avatarUpload: "头像上传",
    dropzone: "Dropzone",
    sticky: "Sticky",
    countTo: "Count To",
    componentMixin: "小组件",
    backToTop: "返回顶部",
    dragDialog: "拖拽 Dialog",
    dragSelect: "拖拽 Select",
    dragKanban: "可拖拽看板",
    charts: "图表",
    keyboardChart: "键盘图表",
    lineChart: "折线图",
    mixChart: "混合图表",
    example: "综合实例",
    nested: "路由嵌套",
    menu1: "菜单1",
    "menu1-1": "菜单 1-1",
    "menu1-2": "菜单 1-2",
    "menu1-2-1": "菜单 1-2-1",
    "menu1-2-2": "菜单 1-2-2",
    "menu1-3": "菜单 1-3",
    menu2: "菜单 2",
    Table: "Table",
    dynamicTable: "动态 Table",
    dragTable: "拖拽 Table",
    inlineEditTable: "Table 内编辑",
    complexTable: "综合 Table",
    tab: "Tab",
    form: "表单",
    createArticle: "创建文章",
    editArticle: "编辑文章",
    articleList: "文章列表",
    errorPages: "错误页面",
    page401: "401",
    page404: "404",
    errorLog: "错误日志",
    excel: "Excel",
    exportExcel: "导出 Excel",
    selectExcel: "导出 已选择项",
    mergeHeader: "导出 多级表头",
    uploadExcel: "上传 Excel",
    zip: "Zip",
    pdf: "PDF",
    exportZip: "Export Zip",
    theme: "换肤",
    clipboardDemo: "Clipboard",
    i18n: "国际化",
    externalLink: "外链",
    profile: "个人中心",
  },
  navbar: {
    dashboard: "首页",
    github: "项目地址",
    logOut: "退出登录",
    profile: "个人中心",
    theme: "换肤",
    size: "布局大小",
  },
  login: {
    themeSet:'主题设置',
    themeBlue:'蓝色主题',
    themeGreen:'绿色主题',
    title: "系统登录",
    welcome: "欢迎登录",
    logIn: "登录",
    username: "用户名",
    password: "密码",
    sign: "快速注册",
    forgot: "忘记密码",
    copyright: "版权所有：中国汽车技术研究中心有限公司",
    userIdForgot: "忘记用户名",
    language: "语 言：",
    remember: "记住登录状态",
    userIdNull: "用户名不能为空",
    passwordNull: "密码不能为空",
    any: "随便填",
    thirdparty: "第三方登录",
    thirdpartyTips: "本地不能模拟，请结合自己业务进行模拟！！！",
    slider: "请拖住滑块，拖动到最右边",
    successText: "验证成功",
    sliderVerifyText: "请滑动滑块进行验证",
  },
  firstPage: {},
  documentation: {
    documentation: "文档",
    github: "Github 地址",
  },
  permission: {
    addRole: "新增角色",
    editPermission: "编辑权限",
    roles: "你的权限",
    switchRoles: "切换权限",
    tips: "在某些情况下，不适合使用 v-permission。例如：Element-UI 的 el-tab 或 el-table-column 以及其它动态渲染 dom 的场景。你只能通过手动设置 v-if 来实现。",
    delete: "删除",
    confirm: "确定",
    cancel: "取消",
  },
  guide: {
    description: "引导页对于一些第一次进入项目的人很有用，你可以简单介绍下项目的功能。本 Demo 是基于",
    button: "打开引导",
  },
  components: {
    documentation: "文档",
    tinymceTips: "富文本是管理后台一个核心的功能，但同时又是一个有很多坑的地方。在选择富文本的过程中我也走了不少的弯路，市面上常见的富文本都基本用过了，最终权衡了一下选择了Tinymce。更详细的富文本比较和介绍见",
    dropzoneTips: "由于我司业务有特殊需求，而且要传七牛 所以没用第三方，选择了自己封装。代码非常的简单，具体代码你可以在这里看到 @/components/Dropzone",
    stickyTips: "当页面滚动到预设的位置会吸附在顶部",
    backToTopTips1: "页面滚动到指定位置会在右下角出现返回顶部按钮",
    backToTopTips2: "可自定义按钮的样式、show/hide、出现的高度、返回的位置 如需文字提示，可在外部使用Element的el-tooltip元素",
    imageUploadTips: "由于我在使用时它只有vue@1版本，而且和mockjs不兼容，所以自己改造了一下，如果大家要使用的话，优先还是使用官方版本。",
  },
  table: {
    dynamicTips1: "固定表头, 按照表头顺序排序",
    dynamicTips2: "不固定表头, 按照点击顺序排序",
    dragTips1: "默认顺序",
    dragTips2: "拖拽后顺序",
    title: "标题",
    importance: "重要性",
    type: "类型",
    remark: "点评",
    search: "搜索",
    add: "添加",
    export: "导出",
    reviewer: "审核人",
    id: "序号",
    date: "时间",
    author: "作者",
    readings: "阅读数",
    status: "状态",
    actions: "操作",
    edit: "编辑",
    publish: "发布",
    draft: "草稿",
    delete: "删除",
    cancel: "取 消",
    confirm: "确 定",
    index: "序号", // No.
  },
  example: {
    warning: "创建和编辑页面是不能被 keep-alive 缓存的，因为keep-alive 的 include 目前不支持根据路由来缓存，所以目前都是基于 component name 来进行缓存的。如果你想类似的实现缓存效果，可以使用 localStorage 等浏览器缓存方案。或者不要使用 keep-alive 的 include，直接缓存所有页面。详情见",
  },
  errorLog: {
    tips: "请点击右上角bug小图标",
    description: "现在的管理后台基本都是spa的形式了，它增强了用户体验，但同时也会增加页面出问题的可能性，可能一个小小的疏忽就导致整个页面的死锁。好在 Vue 官网提供了一个方法来捕获处理异常，你可以在其中进行错误处理或者异常上报。",
    documentation: "文档介绍",
  },
  excel: {
    export: "导出",
    upload:"上传",
    selectedExport: "导出已选择项",
    placeholder: "请输入文件名(默认excel-list)",
  },
  zip: {
    export: "导出",
    placeholder: "请输入文件名(默认file)",
  },
  pdf: {
    tips: "这里使用   window.print() 来实现下载pdf的功能",
  },
  theme: {
    change: "换肤",
    documentation: "换肤文档",
    tips: "Tips: 它区别于 navbar 上的 theme-pick, 是两种不同的换肤方法，各自有不同的应用场景，具体请参考文档。",
  },
  tagsView: {
    refresh: "刷新",
    close: "关闭",
    closeOthers: "关闭其它",
    closeAll: "关闭所有",
  },
  settings: {
    title: "系统布局配置",
    theme: "主题色",
    tagsView: "开启 Tags-View",
    fixedHeader: "固定 Header",
    sidebarLogo: "侧边栏 Logo",
  },
  /*通用*/

  /*菜单-部门管理*/
  orgManage: {
    alert: "请先选择一个节点!",
    confirm: "如果存在下属部门，也将同时被删除，确认继续吗?",
    successDel: "删除已成功!",
    alertDel: "请先选择要删除的部门!",
    successSave: "信息已成功保存!",
    alertSave: "请选择一个要保存的企业或部门信息!",
    alertNoName: "企业/部门名称不能为空!",
    exist: "企业/部门名称已存在!",
    depManage: "部门管理",
    manage: "管理",
    addDep: "添加部门",
    delDep: "删除部门",
    ent: "企业",
    depUnit: "部门单位",
    depName: "部门名称",
    engName: "英文名称",
    frName: "外文名称",
    statusFlagId: "企业身份标识",
    agencyCode: "税号",
    alertNoOrgCode: "企业税号不能为空！",
    dunsCode: "DUNS编码",
    country: "国家/地区",
    city: "城市",
    address: "地址",
    postCode: "邮政编码",
    homepage: "主页",
    mainProducts: "主营业务", // Main Business
    save: "保存",
    depManage2: "部门管理",
  },
  /*菜单-企业用户管理*/
  entorguser: {
    title: "企业用户信息",
    sechstandard: "查找:",
    enterprises: "企业",
    orgname: "部门",
    orgnameandenterprises: "企业(部门)",
    Serialnumber: "序号",
    userstatus: "有效性",
    loginname: "用户登录名",
    username: "姓名",
    lianxiren: "联系人",
    ok: "是",
    no: "否",
    page1: "显示",
    findallpage: "查询到",
    page2: "条",
    page3: "页",
    prepage: "上一页",
    nextpage: "下一页",
    view: "查看",
    revised: "修改",
    maintitle: "中国汽车材料数据系统",
    statusTitle: "管理",
    sendTable: ">> 查找本企业用户",
    null: "无",
    up_download: "上传/下载授权",
    button: {
      create: "创建",
      query: "查找",
      cancel: "取消",
    },
    script: {
      select: "请选择一条！",
    },
    resulst: {
      null: "没有符合条件的数据!",
    },
    lixian: {
      shouquan: "离线授权",
    },
  },
  usermessage: {
    title: "企业用户信息",
    title2: "查看本企业用户信息",
    enterprises: "企业:",
    loginnam: "用户登录名:",
    email: "电子邮箱:",
    username: "姓名:",
    telephone: "电话号码:",
    fax: "传真号码:",
    orgname: "部门:",
    button: {
      cancel: "返回",
      save: "提交",
    },
    seandtitle: "中国汽车材料数据系统",
    title1: "企业用户管理",
    statusTitle: "管理",
    upload: "上传",
    updateok: "用户权限设置成功",
    download: "下载",
    up_download: ">>用户上传/下载权限设置",
    up_download1: "用户上传/下载权限设置",
    uploaderror: "企业上传用户人数已满",
    downloaderror: "企业下载用户人数已满",
    up_downloaderror: "企业上传下载用户已满",
    unup_download: "企业未开通上传下载功能",
    cosset: ">>用户离线权限设置",
    cosset1: "用户离线权限设置",
    putong: "普通用户",
    gaoji: "高级用户",
    pleaseselect: "请选择离线权限！",
    yiman: {
      putong: "企业COS普通用户已满",
      gaoji: "企业COS高级用户已满",
    },
    wugaibian: "权限无改变不需保存！",
    permission: "企业未开通离线工具（COS）权限",
    false: "设置失败",
  },
  entorguserinput: {
    script: {
      message: {
        chkName: "姓名不能为空",
        chkEMail: "邮箱不能为空",
        chkEMailC: "两次输入的邮箱不一致，请重新输入！",
        chkEMailgeshi: "邮箱的格式不正确！",
        chkTelephone: "电话号码不为空",
        chkFax: "传真号码不能为空",
        dateType: "有效起始日与有效终至日不能为空，且为时间类型",
        dateFromTo: "有效终至日必须大于有效起始日",
        select: "请选择一条或多条部门！",
      },
    },
    title: "创建企业用户",
    title2: "修改企业用户",
    create: "修改本企业用户",
    effective: "是否有效",
    usermeddage: '用户信息:        带(<span style="color: red;">*</span>)的为必填项！',
    title1: "企业用户管理",
    statusTitle: "管理",
    enterprises: "企业:",
    loginname: "用户登录名:",
    email: "电子邮箱:",
    emailConfirm: "电子邮箱确认:",
    username: "姓名:",
    telephone: "电话号码:",
    fax: "传真号码:",
    passworddata: "密码数据:",
    datefrom: "有效起始:",
    todate: "有效终至:",
    access: "访问权限:",
    description: "描述:",
    tomail: "此用户的密码信息已发到此用户的邮箱中！",
    orgname: "部门单位",
    addorg: "添加",
    delect: "删除",
    operation: "操作",
    isAddNewUser1: "确定要为邮箱为",
    isAddNewUser2: "的用户注册CAMDS账号吗？",
    addafter: "用户已创建成功，其相关信息已发送至其注册邮箱!",
    updataok: "已修改成功！",
    button: {
      save: "提交",
      back: "返回",
      add: "添加部门",
      remove: "移除部门",
      resetpassword: "重置密码",
      select: "(请选择……)",
    },
    lianxiren: "该用户是否是部门的联系人",
    maintitle: "中国汽车材料数据系统",
    bdelorg: "一个企业至少有一个联系人！",
    myorgisnotdel: "本企业用户不能删除！",
    delisok: "删除成功！",
    updateisok: "修改成功！",
  },
  //企业查找
  enterprise: {
    name: "企业名称",
    enterprise: "企业",
    search: "查找",
    standardlookup: "查找标准",
    department: "部门",
    enterpriseidentifier: "企业ID:",
    identifierorganization: "企业/部门-ID:",
    departmentName: "部门名称",
    city: "城市",
    user: "用户姓名",
    DUNScoding: "DUNS编码",
    useridentifier: "用户登录名",
    postalcode: "邮政编码",
    oCode: "税号",
    country: "国家/地区",
    number: "序号",
    see: "查看",
    adoption: "应用",
    return: "确定",
    cancel: "取消",
    identifier: "ID",

    mustSelect: "请选择一条查询结果",
    detail: "企业详情",
    date: "企业相关数据",
    englishName: "英文企业全称",
    foreignLanguage: "外文企业全称",
    post: "地址",
    one: "必须输入其中一项",
  },
  /*菜单-上传/下载权限设置*/
  updownloadnums: {
    orgname: "企业名称",
    uploadusers: "上传用户数",
    downloadusers: "下载用户数",
    inputorgname: "请输入企业名称!",
    selorgname: "请选择企业名称!",
    entUpDownSet: "企业上传/下载权限设置",
    index: "序号",
  },
  /*菜单-消息*/
  message: {
    text:"消息",
    messageType:"消息类型",
    deleteAll: "全部删除",
    messageAll:"全部消息",
    messageCustomer:"客户推送消息",
    messageSystem:"系统消息",
    messageEnterprise:"企业相关消息",
    messageMds:'MDS消息',
    messagePush:"推送",
    confirmMessagePush:"是否确认推送？",
    messagePublicly:"公开发布消息",
    messageDisclosureAndPush:"信息公开和推送",
    pushRecords:"推送记录",
    systemUpdatePush:"系统更新推送",
    regulatoryUpdatePush:"法规更新推送",
    customerRequestsPushNotifications:"客户要求推送",
    PushLinkAddress:"推送连接地址",
    PushTargetSuppliers:"推送目标供应商",
    NoPushTargetSuppliersTips:"推送目标供应商不能为空",
    customerContactInformation:"客户联系方式",
    alreadyViewed:"已查看",
    notBrowsed:"尚未浏览",
    replied:"已回复",
    checkDeleteAll: "确认删除所有消息？",
    num: "序号",
    date: "创建时间",
    content: "消息内容",
    link:'链接地点',
    send: "发送人",
    company: "企业",
    org: "部门",
    delisok: "删除成功！",
    unableToApprove: "表单校验错误数据无法批准!",
    replaced: "无法编辑当前节点!",
    submitECHAnotSupport: "该模块尚未开发，敬请期待！",
    goscip: "生成通报BOM成功！是否前往SCIP通报页面进行信息填报？",
    chachError: "校验未通过，无法导出!",
    downloadSuccess: "下载成功!",
    selectOne: "请选择一条数据!",
    mustFill: "请填写必填项!",
    selectStatus: "请选择数据状态相同的数据!",
    deleteSuccess: "删除成功!",
    formError: "未填写必填项或填写有误!",
    editSuccess: "编辑成功!",
    addSuccess: "新增成功!",
    uploadSuccess: "上传成功!",
    formatError: "文件格式错误，请导入正确模板!",
    loding: "加载中...",
    approve: "确认审核通过？",
    ReviewTheSuccess: "审核成功!",
    ReCheckSuccessful: "重新校验成功!",
    BOM_structure: "请选择数据状态相同且没有BOM结构的数据!",
    Copy: "复制成功!",
    afterBOMlocked: "BOM锁定后将无法进行编辑和删除，确认是否锁定?",
    afterBOMunlocked: "BOM解锁后将可以进行编辑和删除，确认是否解锁?",
    lock: "锁定成功!",
    unlock: "解锁成功!",
    oneFile: "只能上传一个文件,请删除之前上传文件!",
    fileType: "支持word、excel、ppt、pdf文件",
    success: "成功!",
    PasswordResetTo: "密码重置为",
    confirmWhetherToReset: "，确认是否重置？",
    ResetSuccess: "重置成功!",
    twoPassword: "两次输入密码不一致!",
    remark: "备注:每日更新",
    annotatedsuccess: "自动标注成功!",
    selectnode: "请选择节点!",
    cannotFilled: "当前节点无法填报!",
    unannotated: "当前节点无法取消标注!",
    cancellation: "确认取消填报？",
    CancelSuccessful: "取消标注成功!",
    annotated: "当前节点无法标注!",
    cancelling: "确认取消有害标注？",
    cancellationsuccessful: "取消有害标注成功!",
    Confirmthecancellation: "确认取消回收利用率信息标注？",
    cancelledSuccessfully: "取消回收利用率信息标注成功!",
    cannotBeAdded: "当前节点无法新增!",
    CannotEditRoot: "无法编辑根节点!",
    cannotEdited: "当前节点无法编辑!",
    notDeleted: "无法删除根节点!",
    cannotdeleted: "当前节点无法删除!",
    Cannotrootnode: "无法挂接根节点!",
    nothooked: "当前节点无法挂接!",
    Nodatafound: "未查询到数据!",
    Pleasequery: "请查询!",
    selectApiece: "请选择一条数据!",
    onepieceofdata: "只能选择一条数据!",
    datainvalid: "当前数据无效!",
    notApproved: "当前数据未批准!",
    analysisnode: "请选择分析节点!",
    substanceAnalysis: "请选择零部件进行有害物质分析!",
    clearlabel: "是否清空标注？",
    clearlabelsuccessfully: "清空标注成功!",
    verificationSuccessful: "标注校验通过!",
    markComplete: "标注完整，是否进行锁定!",
    uploadFile: "请上传文件!",
    Currently: "当前只能同步前一天的数据!",
    time_consuming: "全量同步，耗时较长!",

    FillUserName: "请点击“切换账号查询”按钮，填写正确的CAMDS同步用户信息！",
    FillPassword: "请点击“切换账号查询”按钮，填写正确的CAMDS同步用户信息！",
    FillCompanyID: "请点击“切换账号查询”按钮，填写正确的CAMDS同步用户信息！",
    matchingSuccess: "匹配成功!",
    phone: "请输入正确联系电话!",
    email: "请输入正确的电子邮箱!",
    uploadSize: "上传文件最大为50M!",
    ConfirmDownload: "确认是否下载?",
    range: "填写范围为0-100!",
    maximumGreater: "最大值必须大于最小值!",
    minimumGreater: "最小值必须小于最大值!",
    UnableEdit: "无法添加编辑中或无效的组件!",
    beenLoaded: "已加载全部数据!",
    ReleaseSuccess: "发布成功!",
    CannotReplaceTheComponent: "无法置换编辑中或无效的组件!",
    currentSynchronizeTheState: "当前数据无法同步状态!",
    SynchronizationStatusSuccessful: "同步状态成功!",
    InquireNoThisSubstance: "查询无此物质!",
    locateTheNodeFirst: "请先定位节点!",
    selectDepartmentInformation: "请选择部门信息!",
    selectTheMDSContact: "请选择MDS联系人!",
    matchingSuccessful: "校验通过!",
    CQCsuccessfully: "创建CQC成功!",
  },
  /*菜单-上传下载统计*/
  statistics: {
    EnterpriseName: "企业名称",
    EnterpriseID: "企业ID",
    EnterpriseManager: "企业管理员姓名",
    UpDownNum: "拥有上传/下载权限用户个数",
    UploadUserNum: "上传",
    DownloadUserNum: "下载",
    Number: "个",
    EntUploadToalCount: "企业上传计费节点数",
    UserName: "用户姓名",
    UploadMDSNum: "上传表单数",
    UploadMDSCount: "上传计费节点数",
    DownloadMDSNum: "下载表单数",
  },
  /*菜单-企业信息管理*/
  org: {
    search: "查询时间",
    start: "开始时间",
    end: "结束时间",
    txt: {
      approve: "批准",
      refuse: "拒绝",
    },
    modCname: "修改公司名称",
    modMailbox: "修改管理员邮箱",
    index: "序号",
    oldname: "原公司名称",
    newname: "新公司名称",
    contackname: "CAMDS登录名",
    mail: "新邮箱地址",
    file: "文件",
    type: "修改类型",
    createDate: "申请时间",
    updateDate: "更新时间",
    status: "状态",
    edit: "待处理",
    app: "已处理",
    res: "已拒绝",
  },
  /*菜单-证书管理*/
  certificate: {
    batch: "批次",
    button: {
      serch: "查找",
      addbatch: "添加批次",
      serchcer: "查找证书",
      import: "导入证书",
      modifybatch: "修改批次",
      delbatch: "删除批次",
    },
    input: "请输入批次",
    id: "证书编号",
    name: "企业名称",
    location: "培训地点",
    username: "姓名",
    department: "部门",
    duty: "职务",
    tel: "座机",
    mobile: "手机",
    email: "邮箱",
    identity: "身份证号",
    address: "地址",
    clevel: "培训等级",
    trainingDate: "培训日期",
    issueDate: "发证日期",
    expireDate: "证书有效期",
    centId: "企业ID",
    midLevel: "培训等级",
  },
  /*菜单-上传Mds*/
  mdsupload: {
    button: {
      upload: "上传",
      view: "查看",
      delete: "删除",
    },
    status: {
      success: "成功",
      failure: "失败",
    },
    mdsUploadSuccess:'MDS-csv上传成功',
    mdsUploadError:'MDS-csv上传失败',
    time: "上传时间",
    filename: "文件名",
    uploadstatus: "操作结果",
    status:"状态",
    mdsid: "MDS ID",
    uploadCount: "计费节点数",
    sample: "是否匹配初级mds?",
    issamplemds: "是",
    notsamplemds: "否",
    cieIdError: "指定表单ID错误",
    cieIdMatch: "指定ID匹配不成功",
    cieSymbolMatch: "材料数据表零部件号、半成品号、材料号匹配不成功,是否继续上传？",
  },
  /*信任用户*/
  trustuser: {
    sechstandard: "查找标准:",
    enterprises: "企业:",
    query: "查询",
    trustuser: "可信用户:",
    inputinfo:"请您给出至少一个查询标准！",
    orgname: "部门:",
    username: "姓名:",
    email: "电子邮箱:",
    button: {
      query: "查找",
      cancel: "取消",
    },
    username2: "姓名",
    enterprise: "企业（部门）",
    valid: "有效的",
    yes: "是",
    no: "否",
    view: "查看",
    modify: "修改",
    modelname: "信任用户查看",
    save: "保存",
    cancel: "返回",
    userInfo: "用户信息：",
    infoTitle: "保密的基本物质:",
    infoContent: "是否允许用户浏览本企业材料数据表中所使用的保密物质:",
  },
  //供应商查询
  supplierSearch: {
    inputQueryConditions: "请输入查询条件",
    startDate: "注册开始日期",
    endDate: "注册结束日期",
    dateTime: "[年(4位)-月(2位)-日(2位)]",
    query: "查询",
    noStartDate: "请输入开始时间！",
    noEndDate: "请输入结束时间！",
    orgId: "企业ID",
    orgName: "企业名称",
    orgEname: "英文名称",
    address: "地址",
    createDate: "注册日期",
    userName: "企业联系人",
    telephone: "联系电话",
    email: "邮箱",
  },
  /*菜单-Mds更新*/
  mdsupdate: {
    analyse_title: "需要更新的材料数据表",
    analyse_type: "材料数据表类型",
    all: "全部",
    com: "零部件",
    semi: "半成品件",
    mat: "材料",
    analyse_name: "名称",
    comnumber: "件号",
    id: "ID",
    analyse_analysetype: "可更新的材料数据表",
    own: "自己的",
    mds: "材料数据表",
    mudule: "组建单元",
    updatedate: "更新日期",
    supplier_mds: "供应商的材料数据表",
    approval: "已批准的",
    search: "查找",
    update: "更新",
    analyse_button_cancel: "取消",
    number: "序号",
    need_to_be_updated_cid: "需要更新的表单ID",
    need_update_cver: "需要更新的表单版本",
    to_be_update_cid: "待更新的表单ID",
    to_be_update_cver: "待更新的表单版本",
    able_to_cid: "可更新的表单ID",
    able_to_cver: "可更新的表单版本",
    please_select_one: "请至少选择一条进行更新",
    update_result: "更新结果",
    must_select_one: "必须选中自己的材料表单或者已批准的表单中的一项",
  },
  // mdsResult: {
  //   index: "序号",
  //   proName: "产品名称",
  //   CproName: "供货名称",
  //   proNameForMaterial: "名称,>材料标识<",
  //   CproNameForMaterial: "供货名称,>材料标识<",
  //   longDes: "零部件号,半成品件号,材料号",
  //   ClongDes: "供货编号",
  //   shortDes: "零部件号,半...",
  //   refstandard: "引用标准",
  //   version: "版本",
  //   asCreateTime: "创建时间",
  //   mustSelect: "请先选择一个查询结果",
  // },
  //注册供应商
  comRedister: {
    comRedister: '企业注册',
    inPutComRegister0: "请确保您的供应商企业没有在CAMDS中注册。",
    inPutComRegister: '请在此处输入供应商企业的有关数据． 所有标记有（<span style="color: red;">*</span>）的字段都必须填写．',
    comData: "企业相关数据：",
    duns: "DUNS编码：",
    dunstitle: "DUNS格式为 99-999-9999",
    orgName: "企业全称：",
    orgEname: "英文企业全称：",
    orgFname: "外文企业全称：",
    character: "不允许含有非法字符！",
    orgCode: "税号：",
    country: "国家/地区：",
    province: "省市：",
    address: "地址：",
    postCode: "邮政编码：",
    companyHomepage: "主页：",
    companyMainProduct: "主营业务：",
    statusFlag: "企业身份：",
    statusFlag1: "供应商",
    msg_1: "请在此输入供应商的企业管理员信息。该用户是供应商企业内的一名员工，不是本企业的员工。他（她）负责为其所在企业内的其他用户注册。",
    msg_2: "请确保企业管理员的电子邮箱地址是正确的。 CAMDS会将用户信息发送到该邮箱中。",
    admin: "企业管理员：",
    name: "姓名：",
    telephoneNo: "联系电话：",
    fax: "传真号码：",
    email: "电子邮箱：",
    emailConfirm: "电子邮箱确认：",
    save: "注册",
    back: "返回",
    msg_orgName: "请输入正确的企业全称．",
    msg_orgEname: "您没有输入英文企业全称或输入字符小于2个字符,且不能以数字开头.",
    message_duns: "请输入含有9位数的DUNS编码,注意在第2和第5位数字后加上连接符“-”(例如：12-345-6789).",
    msg_orgCode: "请输入正确的税号。",
    msg_address: "请输入正确的地址．",
    msg_mainProducts: "请输入主营业务．",
    msg_postCode: "邮政编码只能输入数字．",
    msg_name: "请输入正确的企业管理员的姓名．",
    msg_telephoneNo: "请输入联系电话且只能为数字。",
    msg_fax: "请输入传真号码且只能为数字。",
    msg_email: "输入企业管理员的电子邮箱地址（名字@域）.",
    msg_emailConfirm: "两次输入的邮箱不一致，请重新输入！",
    onlineInfo: "在线注册已经完成.您注册的邮箱稍后将收到一封带有存取CAMDS数据的电子邮件，如有问题请联系CAMDS服务中心。",
    redisterSuccess: "注册成功",
    enterpriseType:"企业类型",
  },
  /*菜单-Svhc分析*/
  analyseSvhc: {
    txt_file: "清单上传",
    button_download: "下载模板",
    button_downloadSvhc: "导出",
    index: "序号",
    proName: "产品名称",
    shortDes: "零部件号,半成品件号,材料号",
    version: "版本",
    asSupply: "供应商",
    svhc: " 是否含有超过0.1%的SVHC",
    componentName: "零部件名称",
    number:"数量",
    uploadResult:"上传结果",
    analyseResult:"分析结果",
    matchResult:"匹配结果"
  },
  //用户操作日志
  queryUserLogAction: {
    loginUser: "登录名",
    company: "企业",
    startDate: "开始时间",
    endDate: "结束时间",
    operationType: "操作类型",
    query: "查询",
    exportToCsv: "导出CSV",
    exportToXls: "导出EXCEL",
    username: "用户姓名",
    logOperateDate: "操作时间",
    operationContent: "操作详细内容",
  },
  //修改指定的企业信息
  modify: {
    modify: "修改指定的企业信息",
    com: "相关企业",
    search: "查询",
    inPutComRegister: '请在此处输入您企业的有关数据. 所有标记有(<span style="color: red;">*</span>)的字段都必须填写.',
    comData: "企业相关数据：",
    admin: "查看企业所有用户",
    save: "保存",
    back: "返回",
    companyHomepage: "企业主页:",
    companyMainProduct: "主营业务:",
    contractStartDate: "合同开始日期:",
    contractEndDate: "合同截止日期:",
    check_dateFromTo: "开始日期必须小于结束日期",
    msg_orgName: "请输入企业全称且不能以数字开头.",
    msg_countryName: "请输入国家或地区.",
    msg_address: "请输入地址.",
    msg_mainProducts: "请输入主营业务.",
    msg_postCode: "请输入数字.",
    pause: "暂停",
    recovery: "恢复",
    deregister: "注销",
    updatesuccess: "保存成功",
  },
  mainpage: {
    statusFlagId: "企业身份标识",
    statusFlag1: "整车企业",
    statusFlag2: "供应商",
    statusFlag3: "整车及供应商",
    statusFlag4: "材料企业",
  },
  //企业管理员
  admin: {
    admin: "企业管理员",
    loginName: "登录名",
    name: "姓名",
    telephoneNo: "联系电话",
    fax: "传真",
    email: "电子邮件",
    user: "用户有效性",
    availability: "有效",
    invalidation: "无效",
    role: "用户角色",
    update: "编辑",
    newAdmin: "创建管理员",
    back: "返回",
    selectRecord: "请选择一条记录！",
    userStatus1: "修改用户有效性",
    userStatus: "用户有效性",
    tel: "电话",
    mail: "邮箱",
  },
  newAdmin: {
    newAdmin: "新建管理员",
    name: "姓名:",
    telephoneNo: "联系电话:",
    fax: "传真号码:",
    email: "电子邮箱地址:",
    simpleCheckRule: "简化校验规则默认值:",
    msg_name: "请输入企业管理员的姓名.",
    msg_tel: "请输入联系电话且只能输入数字.",
    msg_fax: "请输入传真号码且只能输入数字.",
    msg_email: "输入企业管理员的电子邮箱地址(名字@域).",
    createSuccess: "创建成功",
    createSuccessInfo: "创建管理员成功，您创建的企业管理员邮箱中稍后将收到一封带有存取CAMDS数据的电子邮箱，如有问题请联系CAMDS服务中心。",
  },
  /*数据转换-*/
  mdsuploadimds: {
    detect: "校验",
    materialcretetype: {
      select: "请选择",
      txt: "材料创建方式",
      match: "匹配优先",
      create: "全部新建",
      noselect: "请选择材料创建方式",
      match1: "仅匹配企业自建材料",
      match2: "仅匹配公开发布材料",
      match3: "仅匹配标准材料",
      match4: "按照自建材料>>公开发布材料>>标准材料顺序依次匹配",
      match5: "按照自建材料>>标准材料>>公开发布材料顺序依次匹配",
      match6: "按照公开发布材料>>自建材料>>标准材料顺序依次匹配",
      match7: "按照公开发布材料>>标准材料>>自建材料顺序依次匹配",
      match8: "按照标准材料>>自建材料>>公开发布材料顺序依次匹配",
      match9: "按照标准材料>>公开发布>>自建材料材料顺序依次匹配 ",
      match11: "创建时间最新",
      match12: "版本最高优于创建时间最新",
      match13: "当前用户创建的（时间最新的数据）",
      match21: "创建时间最新",
      match22: "版本最高优于创建时间最新",
    },
    txt: {
      xmlfile: "XML 文件",
      alertxmlfile: "请选择XML格式的文件",
      time: "上传时间",
      filename: "文件名",
      uploadstatus: "操作结果",
      reason: "失败原因",
      mdsid: "MDS ID",
      mdsName: "MDS名称",
      state: "其他>>",
      uploadmds: "上传MDS",
      uploadCount: "计费节点数",
      checkerror: "校验结果"
    },
    button: {
      view: "编辑",
      delete: "删除",
      detail: "导出详细",
      close: "关闭"
    },
  },
  //下载前搜索（IMDS转换）
  searchImds: {
    downloadMds: "下载",
    mdsName: "零部件/半成品/材料 名称",
    symbol: "零部件/半成品/材料 号",
    cid: "零部件/半成品/材料 ID",
    cver: "版本",
    latestcvel: "最新版本",
    search: "查找",
    listSearch: "清单查找",
    downloadTemplate: "下载模板",
    download: "下载",
    asSupply: "供应商",
    asCreateTime: "创建时间",
    index: "序号",
    proName: "产品名称",
    version: "版本",
    shortDes: "零部件号,半成品件号,材料号",
    warnID: "请输入ID",
    imdsSelect: "超过10条数据，影响上传下载效率，建议10条数据以内！",
    noneSelect: "没有可供下载的MDS",
    uploadFile: "上传文件",
    import: "导入",
    cancle: "取消",
    uploadNewDocument: "上传新文档",
    txt: {
      state: "其他",
      uploadmds: "",
      symbol: "",
      alertcsvfile: "模板错误",
    },
  },
  //scip分析
  searchMds: {
    componentName: "零部件名称:",
    matNum: "材料号:",
    matID: "材料 ID:",
    cver: "版本:",
    scipStatus: "SCIP提交状态:",
    scipScope: "查询范围:",
    phev: "插电式混合动力:",
    published: "自建",
    approved: "已批准",
    referenceMds: "引用申报",
    curVersion: "当前版本",
    allVersion: "所有版本",
    submitted: "已提交",
    unSubmitted: "未提交",
    completed: "已完成",
    failed: "审核失败",
    createBtn: "新建引用",
    search: "查找",
    asSupply: "供应商",
    asCreateTime: "创建时间",
    index: "序号",
    proName: "产品名称",
    version: "版本",
    shortDes: "零部件号,半成品件号,材料号",
    createText: "创建"
  },
  scipanalyse: {
    no: "序号",
    mincomname: "最小零部件名称",
    mincomidver: "最小零部件ID/版本",
    matname: "材料名称",
    matclassify: "材料分类",
    matidver: "材料ID/版本",
    subname: "基本物质名称",
    subquality: "物质质量(g)",
    rule: "法规比例(%)",
    real: "实际比例(%)",
    proportionInArticle:"单一物品中的比例（%）",
    proportionInMaterial:"材料中的比例（%）",
    result: "分析结果",
    button: {
      export: "导出报告",
      bom: "通报",
      analyse: "分析"
    },
    selectRecord: "请选择一条记录！",
    cas: "CAS编号",
    ec: "EC编号",
  },
  // mdsSearchResult: {
  //   scipstartus: "状态",
  //   scipstartusTime: "状态更改日期",
  //   scipnum: "SCIP提交编号",
  //   scipAnalysis: "分析",
  //   checkout: "查看",
  //   modify: "修改",
  //   newSearch: "新的查找",
  //   button: { startus: "状态" },
  // },
  //基础物质管理
  substanceSearchAction: {
    cname: '名称/别名:',
    cas: 'CAS 编号:',
    euIndex: 'EU-Index:',
    einecs: 'EC 编号:',
    class: '物质分类',
    gadsl: 'GADSL分类:',
    gadslOne: '需申报',
    yes: '是',
    no: '否',
    notSure: '未确定',
    gadslTwo: '被禁止',
    reachSvhc: 'REACH-SVHC:',
    svhcview: '高关注',
    thingsId: '物质ID号',
    name: '名称',
    enName: '英文名字',
    search: '查询',
    insert: '添加',
    update: '编辑',
    delete: '删除',
    choose: '请选择记录',
    sureDelete: '确定删除记录 -',
    substancemanager: '基本物质管理',
    substanceinsert: '基本物质添加',
    substanceModify: '基本物质编辑'
  },
  //新增基础物质
  substanceInsertAciton: {
    existNameMsg:'名称已存在',
    existEnNameMsg:'英文名称已存在',
    name: '名称:',
    enName: '英文名称:',
    aliasOne: '别名1:',
    aliasTwo: '别名2:',
    aliasTh: '别名3:',
    gadsl: 'GADSL:',
    gadslTh: '需申报/被禁止',
    svhcy: '是',
    svhcn: '否',
    groupid: '基本物质分组:',
    class: '物质分类:',
    cnameCheck: '名称不能为空',
    thingId: '物质ID号:',
    alias: '别名:',
    addAlias: '增加',
  },
  //CQC查询
  searchVehicleType: {
    chose: " (请选择...)",
    choseAll: " 全部",
    comp: " 接收企业:",
    from: " 从:",
    to: " 到:",
    search: "查找",
    output: "导出",
    cancel: "取消",
    maintitle: "中国汽车材料数据系统",
    bad: "没有符合条件的数据",
    confirm: "选择额外的查询标准可以加快查找.\n\n仍继续吗?",
    yearday: "[年(4位)-月(2位)-日(2位)]",
    noresult: "没有符合条件的数据!",
    title: "查询",
    check_dateType: "日期请按YYYY-MM-DD类型输入",
    check_dateFromTo: "开始日期必须小于结束日期",
    fnc_chkNumber: "请输入数字",
    dateFrom: "从:",
    dateTo: " 到: ",
    dateFormat: "[年(4位)-月(2位)-日(2位)]",
    statusTitle: "状态",
    sendTable: ">> 已发送的材料数据表",
    date: "日期: ",
    dateTime: "(年(4位)-月(2位)-日(2位))",
    status: "状态:",
    status_N: "未完成",
    status_D: "已下载",
    doNot: "未批准的材料数据表",
    name: "名称:",
    language: "语言选择:",
    language_C: "中文",
    language_E: "英文",
    language_F: "外文",
    id: "ID:",
    version: "版本号:",
    startDate: "开始日期",
    endDate: "结束日期",
  },
  vehicleTypeResult: {
    version: " ID/版本",
    vehicleType: " 车辆型号",
    powerPlantType: " 动力装置型号",
    createEnt: " 供应商",
    createTime: " 创建时间",
    view: " 查看",
    copy: " 复制",
    delete: " 删除",
    modify: " 修改",
    bomMatch: " BOM匹配",
    newSearch: "新的查找",
    copyMsg: " 确认复制车型及表单信息",
    cancle: "取消",
    table: " 已发送的材料数据表状态",
    stautsTable: " 已发送>>已发送的材料数据表",
    page: "页",
    pageFirst: " 上一页",
    pageNext: " 下一页",
    num: " 序号",
    name: " 名称",
    status: " 状态",
    queryStandard: " 查找标准: 按照",
    queryStandard2: "排序",
    watch: " 查看",
    modfily: " 修改",
    back: " 返回",
    maintitle: " 中国汽车材料数据系统",
    serachallrec: " 查询到",
    serachallrec1: " 条,",
    pleasechose: "请选择一个条件",
    pagecheck: "请输入正确页码",
    first: "首页",
    last: "尾页",
    di: "第",
    forward: "跳转",
    item: "条",
    searchfor: "查询到",
    screen: "显示",
    downLoad: "下载",
    noneSelect: "没有可供下载的MDS",
    mustSave: "请先保存",
    mustSelect: "请先选择一个查询结果",
    correctPage: "请输入正确页码",
    export: " 导出",
    wait: "稍等",
    mdsMsg: " 该车型尚未创建零部件",
    cqcExportMsg: "导出前请确保数据正确性",
    confirm: " 确定",
    deleteMsg: " 确认删除该数据吗？",
    buildFail: "创建失败",
    buildSuccess: "匹配成功",
  },
  MaterialExtraClass: {
    materialClassification: "\u6750\u6599\u5206\u7c7b",
    description: "\u63cf\u8ff0",
    use: "\u91c7\u7528",
    cancel: "\u53d6\u6d88",
    state: ">>",
    select: "\u8bf7\u9009\u62e9 !",
    create: "\u521b\u5efa",
    selectMaterClass: "\u989D\u5916\u5206\u7C7B-\u7535\u6C60\u76F8\u5173",
    secondaryClass: "\u4E8C\u7EA7\u5206\u7C7B",
    firstClass: "\u4E00\u7EA7\u5206\u7C7B",
  },
  vehicleTypeInfo: {
    projectName: " 项目名称",
    required: " 必填",
    powerPlantType: " 动力装置形式",
    cccApplicationNo: " CCC申请编号",
    vehicleType: " 车型型号",
    vehicleInteriorNumber: " 车辆内部编号",
    vehicleTypeName: " 车型名称",
    curbWeight: " 整备质量",
    reusability: " 可再利用率",
    EnteSh: " 请输入数字",
    recyclability: " 可回收利用率",
    okToSave: " 确定保存吗",
    cancle: "取消",
    title1: "车型信息",
    statusTitle: "车型管理",
    title: ">>创建",
    phev: "插电式混合动力",
    requiredMsg: '车型信息:        带(<span style="color: red;">*</span>)的为必填项！',
    pureElectric: " 纯电动",
    hybrid: " 混合动力",
    fuelCell: " 燃料电池",
    internalCombustionEngine: " 内燃机",
    saveButton: " 保存",
    manualMatching: " 手动匹配",
    BOMMatching: " BOM匹配",
    export: " 导出",
    chakan: "查看",
    wait: "稍等",
    button: {
      back: "返回"
    },
    detect: " 校验",
    mdsMsg: " 该车型尚未创建零部件",
    cqcExportMsg: "导出前请确保数据正确性",
    uploadNewDocument: " 上传新文档",
    import: " 导入",
    uploadFile: " 上传文件",
    saveMsg: " 请先保存",
  },
  //材料数据表统计
  mdsStatistics: {
    title: '材料数据表统计',
    search: '查找',
    orgName: '企业/部门:',
    orgName1: '企业/部门',
    start: '时间段:',
    isSelf: '表单来源:',
    self: '自己的',
    send: '已发送',
    receive: '已接收',
    ent: '企业',
    entid: '标识符',
    postCode: '邮政编码',
    city: '城市',
    country: '国家/地区',
    formSatus: '自己的MDS状态',
    where: '查找标准:',
    n: '尚未浏览',
    d: '已被下载',
    s: '已浏览',
    p: '已批准',
    c: '被发送人取消',
    r: '已拒绝',
    subTitle: '已接收的材料数据表',
    subTitle1: '已发送的材料数据表',
    level2Title: '已接收的查询',
    level2Title1: '已发送的查询',
    queryStandard2: '按照“接收时间” - 降序排序',
    queryStandard3: '按照“发送时间” - 降序排序'
  },

  /*菜单-跟踪*/
  traceMds: {
    name: '材料名称',
    version: 'ID/版本',
    code: '零部件号、半成品件号、材料编号',
    deadLine: '跟踪日期',
    traceStauts: '跟踪',
    mdsStatus1: '编辑模式', //ED
    mdsStatus2: '尚未浏览', //IR
    mdsStatus3: '已浏览', //SD
    mdsStatus4: '已批准', //ST
    mdsStatus5: '已拒绝', //RL
    mdsStatus6: '被发送人取消', //AP
    mdsName: 'MDS名称',
    remark: "备注",
    traceDetails: "跟踪详细信息",
  },
  receivesearch: {
    mdsType: 'MDS类型',
    name: '供货名称',
    version: 'ID/版本',
    code: '供货编号',
    sendTime: '接收时间',
    approveTime: '审批时间',
    sendOrg: '发送企业(部门)',
    sendOrgID: '发送企业ID',
    status: '状态',
    nsen: '尚未浏览',
    acpt: '已批准',
    modi: '已修改',
    prec: '编辑模式',
    seen: '已浏览',
    recd: '已拒绝',
    showTable: '展示列',
    dld: '已被下载',
    cbs: '被发送人取消',
    commitment: '合规承诺',
    commitmentMsgN: '否',
    commitmentMsgY: '是',
    complianceinfo: '承诺书',
    view: '预览',
    watch: '查看',
    favorite: '收藏',
    analyse: '分析',
    trace: '跟踪',
    back: '新的查找',
    approveMds: '批准',
    refusedMds: '拒绝',
    downLoad: '下载'
  },
  sendsearch: {
    back: '返回',
    name:"名称",
    modfily: '修改',
    code: '零部件号、半成品件号、材料号',
    csymbol: '供货编号',
    sendTime: '发送时间',
    sendOrg: '接收企业(部门)[ID]',
    dld: '已被下载',
    modi: '已被修改的'
  },
  mdsStatisticsSend: {
    n: '尚未浏览',
    s: '已被浏览',
    p: '已被批准',
    c: '被发送人取消',
    r: '已被拒绝',
    d: '已被下载',
  },
  mdsStatisticsSelf: {
    all: '所有的',
    ed: '编辑中',
    ir: '内部发布',
    sd: '已发送',
    st: '已提交',
    rl: '已发布',
  },
  forwardData: {
    forwardDataText: "svhc",
    txt: {
      state: "分析",
      forwardData: " 批量转发",
      file: "清单上传"
    },
    mdsName: "零部件名称",
    // symbol: "零部件号",
    cid: "零部件ID / 版本",
    cver: "零部件版本",
    latestcvel: "最新版本",
    search: "查找",
    asSupply: "供应商",
    asCreateTime: "创建时间",
    index: "序号",
    proName: "产品名称",
    version: "版本",
    versionmdsNname: "产品名称",
    shortDes: "零部件号,半成品件号,材料号",
    finded: "查询到",
    count: "条",
    show: "显示",
    page: "页",
    button: {
      browse: "浏览",
      upload: "上传",
      download: "下载模板",
      downloadSvhc: " 导出",
    },
    uploadNewDocument: " 上传新文档",
    wait: "稍等",
    cancle: "取消",
    import: " 导入",
    uploadFile: " 上传文件",
    listSearch: "清单上传",
    imdsSelect: "超过10条数据，影响上传下载效率，建议10条数据以内！",
    noneSelect: "没有可供下载的MDS",
    maskLayer: "正在处理数据，请稍候...",
    svhc: " 是否含有超过0.1%的SVHC",
    // wait: " wait",
    mdsNname: " 产品名称",
    symbol: " 产品零部件号",
    recMdsname: " 产品供货名称",
    recSymbol: " 产品供货编号",
    suppliercode: " 供应商代码",
    recOrgId: " 接受企业ID",
    batch: " 批次",
    forwardMdsId: " 转发后ID / 版本",
    status: " 状态",
    reason: " 原因",
    correctPage: "请输入正确页码",
  },
  //计费节点统计
  countpoint: {
    supplierText: '查找企业',
    type: '类型',
    zhengche: '整车企业计费',
    cai: 'CAI上传计费',
    csv: 'CSV上传计费',
    ic: 'IC上传计费',
    entname: '企业名称',
    all: '全部',
    search: '查找',
    count: '数量',
    ge: '个'
  },
  //分类分析
  analyse: analyse.ZH,
  //创建请求
  mdsdatacreate: {
    cproject: '项目',
    crecpeople: '材料数据 供应商',
    search: '查找',
    mdsdatatype: '材料数据表类型',
    mdspart: '零部件',
    mdshalfpart: '半成品件',
    mdsmaterial: '材料',
    csendpeople: '材料数据接收方(请求方)',
    mdscdeadline: '截止日期',
    requeststatus: '请求状态',
    hadsave: '已保存',
    havenotsave: '尚未保存',
    spanmsg: '预定义的特定接受人信息',
    partNo: '供货编号',
    reportNo: '报表编号',
    rdName: '供货名称',
    reportdate: '报表日期',
    drawingNo: '制图号',
    purChaseOrderNo: '购货订单号',
    drawingDate: '制图日期',
    billOfLadingNo: '提货单号',
    drawingModCodeNo: '制图修改号',
    csupplierCode: '供应商代码',
    reMark: '备注',
    rollback: '返回',
    save: '保存',
    NotForSelfEntprise: '不能将请求发送给本企业',
    mustinput: '请输入所有要求的数据：',
    dateerror: '输入的日期格式错误！有效格式应为: [年(4位)-月(2位)-日(2位)]',
    cdeadLineAfterSysteDate: '截止日期必须在当前日期之后',
    sent: '发送',
    savemessage: '您还没有保存数据。您确定继续操作吗?',
    datahadsave: '数据已保存！',
    datahadsend: '数据已发送！'
  },
  navData: {
    // 首页
    homepage: '首页',
    //数据管理
    dataAdministration: '数据管理',
    essentialData: '基础数据同步',
    MDSData: 'MDS数据同步',
    LocalData: '本地数据管理',
    auditDistribute: '审核分发',
    auditInfo: '审核信息',
    // 系统管理
    systemManage: '系统管理',
    DepartmentManage: '部门信息',
    UserManage: '用户信息',
    PersonalManage: '个人信息',
    RoleManage: '角色信息',
    LogManage: '日志信息',
    ConfigurationManage: '配置信息',
    //车型管理
    VehicleManagement: "车型管理",
    ModelInformation: "车型信息",
    ModelBOMInformation: "车型BOM信息",
    ModelChange: "车型变更扩展",
    PartsChange: "变更零部件",
    PartsExtend: "扩展零部件",
    DangerManage: "高危清单填报",
    // 综合分析
    analysisBySynthesis: "综合分析",
    materialAnalysis: "整车材料分析",
    partMaterialAnalysis: "零件材料分析",
    rbsAnalysis: "禁限用物质分析",
    rbsExemptionAnalysis: "禁限用物质豁免分析 ",
    componentRRRCalculation: "零部件RRR计算",
    RRRcalculationOfTheVehicle: "整车RRR计算",
    RRRlabelingAndScreening: "RRR标注筛选",
    reportToManagement: "报告管理",
    //SCIP对接
    scipDocking: "SCIP管理",
    vehicleSVHCAnalysis: "整车SVHC分析",
    SCIPNotification: "SCIP通报",
    // 规则管理
    ruleManagement: "规则管理",
    reviewTheRules: "审核规则",
    regulatoryInformation: "法规信息",
    taggingRules: "标注规则",
    //信息管理
    informationManagement: "信息管理",
    fileManagement: "文件管理",
    messageReminding: "消息记录",
    //CQC
    fillCQC: "CQC管理",
  },
  placeholder: {
    dataselect: "请选择",
    datainput: "请输入",
    datainputLanguage: "请输入语言",
    none: "无",
  },
  scip: {
    scipName: "物品标识:",
    symbol: "主要物品标识符:",
    add: "添加",
    addPictureFile: "添加图片",
    addFile: "添加文件",
    none: "无",
    modifySuccess: "修改成功",
    dossierSubmissionType: "档案提交类型",
    dossierName: "档案名称",
    dossierSubmissionRemark: "档案提交备注信息",
    dossierSubject: "档案主题",
    dossierCreationTime: "档案创建日期/时间",
    dossierVersion: "版本",
    submissionType: "提交类型",
    SCIPNotification: "SCIP通报",

    identifiers: "标识",
    articleName: "物品名称",
    otherNames: "别名",
    otherNamesType: "类型",
    otherNamesName: "名称",
    primaryArticleIdentifierType: "主要标识类型",
    primaryArticleIdentifierValue: "主要标识号",
    otherArticleIdentifiers: "其他标识",
    otherIdentifiersType: "类型",
    otherIdentifiersValue: "值",

    categorisation: "分类",
    articleCategory: "物品分类",
    productionInEuropeanUnion: "是否在欧盟生产",

    characteristics: "特征",
    pictures: "图片",
    height: "高度",
    length: "长度",
    width: "宽度",
    diameter: "直径",
    density: "密度",
    weight: "重量",
    volume: "容量",
    colour: "颜色",
    safeUseInstructions: "安全使用说明",
    safeUseInstructionsLong: "候选清单物质的识别足以使该物品在整个生命周期(包括使用寿命、拆卸和废物/循环再造阶段)中得到安全使用",
    disassemblingInstructions: "拆解说明",
    attachedDocuments: "附件",

    complexObjectComponent: "复杂物品",
    article: "物品",
    numberOfUnits: "数量",

    concernElement: "关注的成分信息",
    candidateListSubstance: "SVHC物质",
    concentrationRange: "含量范围",
    materialCategories: "材料分类",
    mixCategories: "混合分类:",
    extraCategories: "额外分类:",
    otherMaterial: "其他",
    addMaterialCharacteristic: "附加材料特征",
    mixtureCategory: "混合物分类",
    CandidateListSubstanceLongerPresent: "不再存在的物质",

    referenceSubstanceName: "参考物质名称",
    IUPACName: "IUPAC名称",
    ECNumber: "EC编号",
    CASNumber: "CAS编号",
    ECHASubstanceID: "ECHA物品编号",
  },
  svhc: {
    assemblyPart: "总成零部件名称",
    assemblyPartNum: "总成零部件供货编号",
    assemblyPartID: "总成零部件ID/版本",
    supplierName: "供应商名称",
    part: "最小零部件名称",
    partId: "最小零部件ID/版本",
    materialName: "材料名称",
    materialClassify: "材料分类",
    materialId: "材料ID/版本",
    substanceName: "基本物质名称",
    substanceContent: "物质质量（g）",
    lawsProportion: "法规比例（%）",
    proportionInMaterial:"材料中的比例（%）",
    realProportion: "实际比例（%）",
    analysisResult: "分析结果",
  },
  reg: {
    phone: "请输入正确手机号!",
    email: "请输入正确的邮箱地址!",
    deptId: "企业/部门最多选择10个!",
  },
  tableWidth: {
    cidCver: "160",
    csymbol: "154",
    cname: "200",
    ccreator: "180",
    cstatus: "154",
    setflagInfo: "154",
    cauditInfo: "154",
    time: "200",
    capproveDate: "230",
  },
  tableOptionWidth: {
    camdsDataAdmin_main: "170",
  },
  mdsSearchResult: {
    mustSelect: "请先选择一个查询结果",
    correctPage: "请输入正确页码",
    searchMds: "SCIP分析",
    result: "MDS查询结果",
    search: "表单分析",
    accord: "按照 ",
    asName: "名称",
    asNumber: "条目号",
    reBack:'返回',
    asSupply: "供应商",
    asCreateTime: "创建时间",
    desc: "降序",
    asc: "升序",
    order: "排序",
    checkout: "查看",
    modify: "修改",
    copy: "复制",
    delete: "删除",
    favorite: "收藏",
    preview: "预览",
    analyze: "分析",
    newSearch: "新的查找",
    index: "序号",
    proName: "产品名称",
    CproName: "供货名称",
    proNameForMaterial: "名称，>材料标识<",
    CproNameForMaterial: "供货名称,>材料标识<",
    longDes: "零部件号,半成品件号,材料号",
    ClongDes: "供货编号",
    shortDes: "零部件号,半成品件号,材料号",
    refstandard: "引用标准",
    version: "ID / 版本",
    finded: "查询到",
    count: "条",
    show: "显示",
    page: "页",
    downLoad: "下载",
    downLoadImds: "Imds下载",
    noneSelect: "没有可供下载的MDS",
    Selected: "选择的材料数据表共计：",
    maxCount: "每次最多下载50条记录！",
    maskLayer: "正在处理数据，请稍候...",
    complianceinfo: "承诺书",
    deleteAlert: "已被下载，不能删除",
    overdue: "标记为过期",
    overdeMsg: "标记为过期的数据表，不建议发送、提交或引用",
    effective: "标记为有效",
    effectiveMsg: "标记为有效",
    reach: "REACH报表 ",
    imdsSelect: "超过10条数据，影响上传下载效率，建议10条数据以内！",
    mdsType: " 表单类型",
    scipAnalysis: "分析",
    scipstartus: " 状态",
    scipstartusTime: " 状态更改日期",
    scipnum: "SCIP提交编号",
  },
  scipSearchResult: {
    button: {
      status: " 状态"
    },
    NotAnalyzed: " 未分析",
    NotBlank: "信息不能为空",
    status: " 通报状态",
    scipNumber: " scip编号",
    reportUrl: " 报告链接",
    commitMsg: " 已完成SCIP通报的数据不建议修改和再次通报",
  },
  folder: {
    dialogTitle1:'新增目录',
    dialogTitle2:'编辑目录',
    dialogMDSTitle:'查找定位',
    delmdsmsg:"确定要将此表单从文件夹中移除吗？",
    suremsg: " 确认删除此文件夹及文件夹所有信息？",
    savemsg: " 尚未保存，是现在否保存 ?",
    delmdsmsg: " 确定要将此表单从文件夹中移除吗？",
    selectresult: " 请先选择一个查询结果!",
    selectfolder: " 请先选择一个文件夹!",
    hadsave: " 保存成功!",
    mdsfoldermanage: " 材料数据分类管理",
    mdsfolderother: " 分类管理",
    foldermanage: " 材料数据分类管理",
    folderadd: " 添加",
    del: " 删除",
    edit: " 编辑",
    folderfindmds: " 查找MDS",
    watch: " 查看",
    update: " 修改",
    remove: " 移除",
    copy: " 复制",
    favorite: " 收藏",
    preview: " 预览",
    analyze: " 分析",
    foldername: " 目录名称",
    createtime: " 创建时间",
    entname: " 企业名称",
    creatername: " 创建人姓名",
    reMark: " 备注",
    findnodata: " 未查到您要的结果！",
    returnmsg: "选中的文件夹不存在或未保存!",
    hasSame: "该MDS已存在!",
    editmdsversion: "该数据属于正式版本,不能编辑!",
    hasExist: "该文件夹名已经存在!",
    notNull: "文件夹名称不能为空!",
    save: " 保存",
    firstsave: "请先保存或删除节点！",
    cancel: " 取消",
  },
  popfolder: {
    msg: "请选择一个收藏目录!",
    hadsave: "收藏成功!",
    mdsfoldermanage: "材料数据分类管理",
    mdsfolderother: "分类管理",
    foldermanage: "材料数据分类管理",
    addtofolder: "添加到文件夹",
    save: "收藏",
    cancel: "取消",
  },
  copyMds: {
    copyType: "选择拷贝类型",
    forward: "转发",
    title: "复制MDS",
    newVersion: "新版本",
    copy: "拷 贝",
    continue: "继 续",
    notice: " 此MDS中包含已逻辑删除的MDS,复制过程会将删除的部分从副本中移除,是否继续?",
    cancel: "取 消",
    pleasewait: "请稍等...",
  },
  editmds: {
    treeOperation: "树操作",
    findAndOrientation: "查找定位",
    filterTreeName: "名称",
    filterFind: "滤器",
    fuzzyQuery: "模糊查询",
    accurateQuery: "精确查找",
    filterTreeCode: "零部件号...",
    filterTreeCodeAll:"零部件号,半成品件号,材料编号",
    filterTreeId: "ID--编号",
    version: "ID--编号/版本",
    filterTreeCAS: 'CAS--编号',
    filterNoLoadSub: '不加载基本物质',
    filterNoLoadRef: '不加载引用的mds和组件单元',
    filterTree: '过滤树 ',
  },
};
